import React, { useEffect, useState ,useCallback} from 'react'
import useStyles from './style'
import {
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Collapse,
  Typography,
  Grid,
} from '@mui/material'
import { MenuRounded } from "@mui/icons-material";
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import list from '../../Model/MenuList'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { toggleSidebar } from '../../Redux/Sidebar/actions'
import { CUSTOM_CONSTANTS } from "Constants";
import settingsApi from "Services/Settings";
import _ from "lodash";
// Redux
import { showSnackbar } from "../../Redux/SnackBar/actions";
import { setNewSiteLogo } from "../../Redux/SiteSettings/actions";

const Sidebar = ({profileDetails}) => {
  const classes = useStyles()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const dispatch = useDispatch();
  const [selectedIndex, setSelectedIndex] = useState(pathname)
  const [menuList, setMenuList] = useState(list)
  const [values, setValues] = useState([]);
  const siteNewL = useSelector( 
    (state) => state?.SiteSettingsReducer?.siteNewLogo
  );
  const sidebarOpen = useSelector((state) => state.sidebar.isOpen);
  const userType = useSelector(
    (state) => state?.AuthReducer?.userType || ""
  );

  
 const handleToggleSidebar = () => {
    dispatch(toggleSidebar());
  };

  const handleClick = (index, openState) => {
    const updatedMenuList = menuList?.filter((menu) => menu.for.includes(userType)).map((data, idx) => {
      if (data?.isCollapsible) {
        if (idx === index) {
          return { ...data, open: !openState, active: true }
        } else {
          return { ...data, open: false, active: false }
        }
      } else if (data?.link === selectedIndex) {
        return { ...data, open: openState, active: openState }
      } else {
        return { ...data, open: false, active: false }
      }
    })
    setMenuList(updatedMenuList)
  }
  // Set Settings

  const getMasterValues = useCallback(() => {
    const onSuccess = (res) => {
      if (res?.data?.status === true) {
        //console.log("settings fetched ", res?.data?.data);
        dispatch(
          setNewSiteLogo(res?.data?.data?.siteLogo)
        );
        setValues(res?.data?.data);
      } else {
        setValues([]);
      }
    };
    const onFailure = (err) => {
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    settingsApi.getMasterValues().then(onSuccess, onFailure);
  }, []);

  useEffect(() => {
    setSelectedIndex(pathname)
    getMasterValues();
  }, [pathname, siteNewL, getMasterValues])

  const handleMenuNavigate = (link) => {
    navigate(link)
  }

  // To Open the Active menu Collapsible True when submenu is active
  useEffect(() => {
    let currentArrObj = null
    const currentObjInMainArr = menuList?.find(
      (data) => data?.link === pathname
    )
    if (currentObjInMainArr) {
      currentArrObj = currentObjInMainArr
    } else {
      const currentObjInSubArr = menuList?.find((data) =>
        data?.subMenu?.find((item) => item?.subLink === pathname)
      )
      currentArrObj = currentObjInSubArr
    }
    const updatedMenuList = menuList?.filter((menu) => menu.for.includes(userType)).map((data) =>
      data?.name === currentArrObj?.name
        ? { ...data, open: true, active: true }
        : { ...data, open: false, active: false }
    )
    setMenuList(updatedMenuList)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  return (  
    <>

<Grid container className={ `${sidebarOpen?classes.headstamps:classes.headstamps2}`}>
<Grid item xs={6} md={6} lg={6} xl={6} className={classes.headstampitems} >
  <img
     src={
        !_.isEmpty(profileDetails?.image)
          ? `${profileDetails?.image}`
          : "/assets/images/user/avatar.png"
       }
    alt={profileDetails?.user_name}
    className={classes.logo}
    onClick={() => navigate("/")}
  />
</Grid>
<Grid item xs={6} md={6} lg={6} xl={6} className={classes.headstampitems}>
<MenuRounded
  onClick={handleToggleSidebar}
/>
</Grid>
</Grid>

<section className={`${classes.root} ${sidebarOpen?classes.sidebarmenu:classes.sidebarmenu2}`} >

  {menuList?.filter((menu) => menu.for.includes(userType))
  .map((data, idx) => (
          <List
            key={data?.name}
            component="nav"
            aria-label="navMenu"
            onClick={() =>{
              if (data?.name === "Sign Out") {
                localStorage.clear();  // Clear storage
                navigate(0); // Reload to reset state
              } 
              data?.isCollapsible === false && handleMenuNavigate(data?.link)
            }}
          >
            <ListItemButton
              selected={data?.active === true}
              onClick={() => {
                handleClick(idx, data?.open)
              }}
            >
              <ListItemIcon>
             {data.src && <img src={data.src} alt="sidebar_icons" /> }
              {data.icon && <data.icon />} {/* Render the icon as a component */}
              </ListItemIcon>
           { sidebarOpen && ( 
              <ListItemText
                primary={data?.name}
                className={
                  data?.active === true
                    ? classes.menuLabels
                    : classes.menuLabels2
                }
              />
              ) }
              {/* Accordion Icon */}
{data?.isCollapsible ? (data?.open ? (<ExpandLess />) : (<ExpandMore />)) : (<></>)}
            </ListItemButton>
            
            {/* Accordion */}
            {data?.isCollapsible === true ? (
              <Collapse in={data?.open} timeout="auto" unmountOnExit>
              {data?.subMenu?.filter((sub) => sub.for.includes(userType)).map((item, subIdx) => (
                <div key={item?.name}>
                  <List
                    component="div"
                    disablePadding
                    onClick={() => {
                      if (item?.isCollapsible) {
                        const updatedMenuList = [...menuList];
                        updatedMenuList[idx].subMenu[subIdx].open = !item.open;
                        setMenuList(updatedMenuList);
                      } else {
                        handleMenuNavigate(item?.subLink);
                      }
                    }}
                    className={classes.subMenuLabel}
                    sx={ selectedIndex === item?.subLink ? { background: '#c1c1c16b' } : {} }
                  >
                    <ListItemButton className={classes.subitemscolor}>
                      <ListItemIcon className={classes.subitemsicon}>
                        {item.src && <img src={item.src} alt="sidebar_icons" /> }
                        {item.icon && <item.icon />}
                      </ListItemIcon>
                      {sidebarOpen && (
                        <ListItemText className={classes.subitemscontent}
                          primary={<Typography variant="body1">{item?.name}</Typography>}
                        />
                      )}
                      {item?.isCollapsible ? (item?.open ? <ExpandLess /> : <ExpandMore />) : null}
                    </ListItemButton>
                  </List>

                  {/* recursive collapse for nested submenu */}
                  {item?.isCollapsible && (
                    <Collapse in={item?.open} timeout="auto" unmountOnExit>
                      {item?.subMenu?.map((subSub) => (
                        <List
                          component="div"
                          disablePadding
                          key={subSub?.name}
                          onClick={() => handleMenuNavigate(subSub?.subLink)}
                          sx={ selectedIndex === subSub?.subLink ? { background: '#c1c1c16b' } : {} }
                        >
                          <ListItemButton className={classes.subitemscolor}>
                            <ListItemIcon className={classes.subitemsicon}>
                              {subSub.src && <img src={subSub.src} alt="sidebar_icons" />}
                            </ListItemIcon>
                            {sidebarOpen && (
                              <ListItemText
                                className={classes.subitemscontent}
                                primary={<Typography variant="body2">{subSub?.name}</Typography>}
                              />
                            )}
                          </ListItemButton>
                        </List>
                      ))}
                    </Collapse>
                  )}
                </div>
              ))}
              </Collapse>
            ) : (
              <></>
            )}
          </List>
        ))}

</section>
    </>
  )
}

export default Sidebar
